var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.54544,
    y: 5.73047,
    width: 10.9091,
    height: 9.54182,
    stroke: "#00CC99",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.9367C7.7905 11.9367 8.43133 11.2942 8.43133 10.5016C8.43133 9.70895 7.7905 9.06641 7 9.06641C6.20949 9.06641 5.56866 9.70895 5.56866 10.5016C5.56866 11.2942 6.20949 11.9367 7 11.9367Z",
    stroke: "#00CC99",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 0.727051V0.727051C7.95416 0.727051 8.86924 1.1071 9.54394 1.7836C10.2186 2.46009 10.5977 3.37762 10.5977 4.33432V5.73069H3.40231V4.33432C3.40231 2.34208 5.01305 0.727051 6.99999 0.727051Z",
    stroke: "#00CC99",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.27db6a2c.svg";
export { ForwardRef as ReactComponent };